//axl
import AxL from "./axl";
//audio
import { clickSound } from "./assets/audio/audio";
//board
import { Board } from "./typeOfboard";

export const generateRandomNumber = (maxNumber, minNumber) => {
  const min = minNumber;
  const max = maxNumber;
  const final = min + Math.random() * (max - min);
  return Math.floor(final);
};

export const playSound = (props) => {
  if (props.data) {
    function playPreloadedAudio() {
      if (clickSound.readyState >= 4) {
        clickSound.play();
      } 
      // else {
      //   alert("Audio is still loading. Please wait.");
      // }
    }
    playPreloadedAudio();
    // clickSound.currentTime = 0;
    // clickSound.play();
  }
};

export const cacheImages = async (images) => {
  const imageUrls = Object.values(images);

  imageUrls.forEach((imageUrl) => {
    const img = new Image();
    img.src = imageUrl;
  });
};

export const AxlTracker = (axl, action, label, value, nonInteraction) => {
  axl.sendMessage(AxL.ChildToHost.TRACK, {
    action: action,
    label: label,
    value: value,
    nonInteraction: nonInteraction || false,
  });
};

// export const AxlShare = (image) => {
//   const axl = useAxL();

//   axl.sendMessage(AxL.ChildToHost.SHARE, {
//     title: "Collection is ready",
//     image: image,
//   });
// };

export const randomArtImage = (randomNumber, boardName) => {
  const board = Board.find((board) => board.boardName === boardName);
  return board.artWorkImages[randomNumber];
};

export const loadImage = async (imagePath) => {
  try {
    const response = await fetch(imagePath);
    if (response.ok) {
      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = () => {
          const dataURL = reader.result;
          const base64String = dataURL.split(",")[1];
          resolve(base64String);
        };

        reader.onerror = reject;

        reader.readAsDataURL(blob);
      });
    } else {
      console.error("Failed to fetch the image.");
    }
  } catch (error) {
    console.error("Error loading the image:", error);
  }
};
